<div class="login-main">
    <div class="login-shared-main-body">       
        <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()" class="login-main-body-identity-form-container">
            <div class="login-main-body-title-text">Verify your Identity</div>
            <div class="login-main-body-desc">As an added level of security, choose how you want to receive a verification code:</div>
            <app-login-user-contact-methods [devices]="mfaDevices" [formGroup]="form"></app-login-user-contact-methods>
            <mat-checkbox formControlName="rememberDevice">
                <span>Don't require 2 factor authentication next time I log in from this device.</span>
            </mat-checkbox>
            <div class="login-submit-ctr">
                <button type="submit" class="login-btn-submit" mat-button [disabled]="!form.valid">Send</button>
            </div>
        </form>
    </div>
</div>
